import React from 'react';
import Modal from '../../components/book/steps/components/Modal';
import NewPaymentMethod from './NewPaymentMethod';

const PaymentMethodModal = ({
  close,
  createdPaymentMethodFn,
  isDesktop,
  isOpen,
  paymentMethods,
  stripe
}) => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={close}
      width="500px"
      isDesktop={isDesktop}
    >
      <NewPaymentMethod
        {...{
          closeModal: close,
          createdPaymentMethodFn,
          modal: true,
          paymentMethods,
          stripe
        }}
      />
    </Modal>
  );
};

export default PaymentMethodModal;
